<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('iam.modify_sms_template') }}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :name="$t('iam.message_subscription')" :action="$t('iam.modify_sms_template')" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form-model
        ref="form"
        v-bind="formItemLayout"
        :model="form"
        :rules="rules">
        <a-form-model-item :label="$t('iam.topic.enable_sms')" prop="enable_sms">
          <a-switch v-model="form.enable_sms" :checked-children="$t('common_292')" :un-checked-children="$t('common_293')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('iam.topic.sms_template')" prop="sms_template">
          <a-input v-model="form.sms_template" :placeholder="$t('iam.topic.sms_template.placeholder')" />
          <div class="text-weak mt-1">
            <div v-for="(text, idx) in extraTexts" :key="idx">{{ text }}</div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'
import { getSmsTemplateExtraTexts } from '../utils/smsVars'

export default {
  name: 'NotifyTopicUpdateSmsDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const row = this.params.data[0] || {}
    return {
      loading: false,
      form: {
        enable_sms: row.enable_sms === true || row.enable_sms === 'true',
        sms_template: row.sms_template || '',
      },
      rules: {
        sms_template: { validator: this.validatorTemplate },
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
    }
  },
  computed: {
    extraTexts () {
      return getSmsTemplateExtraTexts(this.params.data[0] || {})
    },
  },
  methods: {
    validatorTemplate (rule, value, callback) {
      if (this.form.enable_sms && !`${value || ''}`.trim()) {
        callback(new Error(this.$t('iam.topic.sms_template.required')))
        return
      }
      callback()
    },
    async doUpdate () {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data: {
            enable_sms: this.form.enable_sms,
            sms_template: this.form.enable_sms ? `${this.form.sms_template || ''}`.trim() : '',
          },
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.doUpdate()
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
